// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ce38f3b5","337":"5ae4cd30","455":"b9ba2d44"}[chunkId] + ".chunk.js";
};